import {CommonModule, KeyValue} from '@angular/common';
import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faArrowRight,
  faCircleExclamation,
  faCircleXmark,
  faFileExcel,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {saveAs} from 'file-saver';
import {BulkImportResultComponent} from '../../shared/bulk-import-result/bulk-import-result.component';
import {
    BulkImportResultView,
    handleBulkImportError,
    handleBulkImportFallbackError,
} from '../../shared/bulk-import-result/bulk-import-result.utils';

@Component({
    selector: 'app-bulk-upload',
    imports: [CommonModule, FontAwesomeModule, BulkImportResultComponent],
    templateUrl: './bulk-upload.component.html',
    styleUrl: './bulk-upload.component.css'
})
export class BulkUploadComponent {
  sampleGuidelines: any = {}
  showModal: boolean = false;
  progress: number = 0;
  bulkImportResult: BulkImportResultView | null = null;
  
  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  constructor(private router: 
              Router, library: FaIconLibrary,
              private apiService: ApiService,
              private toastr: ToastrService){
    library.addIcons(faFileExcel, faUpload, faCircleExclamation, faCircleXmark, faArrowRight)

  }
  downloadTemplate(){
    this.apiService.downloadTemplate().subscribe({
      next: (response: any) =>{
        const contentDisposition = response.headers.get('Content-Disposition');
          let fileName = 'downloaded-file';
        if (contentDisposition) {
          const matches = /filename=([^;]+)/.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = matches[1];
          }
        }
          if (response.body) {
              saveAs(response.body, fileName);
          }
      },
      error: (err) => {
        handleBulkImportFallbackError(err, this.toastr);
      }

      }); 
    }
    

  uploadFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    this.bulkImportResult = null;
    const formData = new FormData();
    formData.append('file', file);
    this.apiService.bulkUpload(formData).subscribe({
      next: (response: any) => {
        this.bulkImportResult = null;
        this.toastr.success(response?.message || 'Vehicles uploaded successfully.', 'Success');
        input.value = '';
      },
      error: (err) => {
        this.bulkImportResult = handleBulkImportError(err, this.toastr, 'vehicle_bulk_upload_failures.csv');
        input.value = '';
      },
    });
  }
  guidelines(){
    this.apiService.uploadGuidelines().subscribe({
      next: (res: any) =>{
        this.sampleGuidelines = res
        if (this.sampleGuidelines){
          this.showModal = true;
        }else{
          this.showModal = false;
        }

      },
      error: (err) => handleBulkImportFallbackError(err, this.toastr),
    });
  }

  closeModal(): void {
    this.showModal = false;
  }
}